export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/hero.2527ed62.svg","height":405,"width":552,"blurWidth":0,"blurHeight":0};